import React from "react";

const PLGrid = () => {
  return (
    <div className="grid-container">
      <div className="grid"></div>
      <div className="grid"></div>
      <div className="grid"></div>
      <div className="grid"></div>
      <div className="grid"></div>
    </div>
  );
};

export default PLGrid;
